import template from './index.html'
import ko from 'knockout'
import item from './radioitem'
import Radio from './base'
import Base from "../../core/base";
const PREFIX = 'y-'
ko.components.register(PREFIX + item.name, {
  viewModel: item.init,
  template: item.template
})
export default {
  name: 'radio',
  init: Base.createViewModel(Radio),
  template
}



// WEBPACK FOOTER //
// ./src/components/radio/index.js